import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Alert, Modal, ModalBody, ModalHeader, Spinner } from 'reactstrap';
import { Button, Col, Icon, Row } from '../../../../components/Component';
import TextInput from '../../../components/inputs/TextInput';
import PhoneInput from 'react-phone-input-2';
import { EMAIL_REGEX, NUMBERS_ONLY_REGEX, ZAMIBAN_PHONE_NUMBER_REGEX } from '../../../../utils/RegexUtils';
import { EDIT_COMPANY_ACCOUNT_API } from '../../../../api/api_data';
import { employee_dashboard_actions_helper } from '../../../../actions/actions_helper';
import * as app_consts from "../../../../constants/react_app_consts";
import { fail_edit_user_account_main_details, loading_edit_user_account_main_details, reset_edit_user_account_main_details, success_edit_user_account_main_details } from '../../../../reducers/dashboard_reducers/user_accounts/edit_user_account_main_details_Slice';
import { UPDATE_USER_ACCOUNT_DETAILS_ACCESS_DENIED_MSG, UPDATE_USER_ACCOUNT_DETAILS_ERR_MSG, UPDATE_USER_ACCOUNT_DETAILS_SUCCESS_MSG } from '../../../../constants/success_error_messages_consts';
import { messageToast } from '../../../../utils/Utils';
import { useSelector } from 'react-redux';

const initialState = {
 company_name: "",
 pacra_registration_number: "",
 tax_number: "",
 company_email_address: "",
 company_mobile_number: "",
 unique_identification_number: "",
 iso_code_2: ""
};

const EditCompanyDetailsModal = ({ isOpen, cloasModal, successFunction, data }) => {

 const [open, setOpen] = useState(isOpen);
 const [error, setError] = useState("");
 const [loading, setLoading] = useState(true);
 const [page_data, setPageData] = useState([]);
 const [received_data, setReceivedData] = useState(data);
 const dispatch = useDispatch();
 const [formData, setFormData] = useState(initialState);
 const [submit_loading, setSubmitLoading] = useState(false);
 const [submit_error, setSubmitError] = useState("");
 const [selected_table_data, setSelectedTableData] = useState([]);

 useEffect(() => {
  setOpen(isOpen);
  if (data && isOpen)
  {
   setReceivedData(data);
   setFormData({ ...formData, unique_identification_number: data?.user_account?.unique_identification_number, company_name: data?.company_details?.company_name, pacra_registration_number: data?.company_details?.pacra_registration_number, tax_number: data?.company_details?.tax_number, company_email_address: data?.company_details?.company_email_address, company_mobile_number: data?.company_details?.company_mobile_number });
   setPacra_Number(data?.company_details?.pacra_registration_number);
   setTax_Number(data?.company_details?.tax_number);
   setemail_Address(data?.company_details?.company_email_address);
   setPhoneNumber(data?.company_details?.company_mobile_number);
  }
 }, [data, isOpen]);

 // Handle Input Changes
 const handleChange = (e) => {
  const name = e.target.name;
  const value = e.target.value;
  if (name === "pacra_registration_number")
  {
   setPacra_Number(value);
  } else if (e.target.name === "tax_number")
  {
   setTax_Number(value);
  } else if (e.target.name === "company_email_address")
  {
   setemail_Address(value);
  } else if (e.target.name === "company_mobile_number")
  {
   setPhoneNumber(value);
  }
  setFormData({ ...formData, [name]: value });
 };

 //Checking Valid Phone Number
 const [comp_phone_number, setPhoneNumber] = useState("");
 const [validPNumber, setValidPNumber] = useState(false);
 const [inputPNumberFocus, setInputPNumberFocus] = useState(false);

 //Checking Valid Email Address
 const [email_Address, setemail_Address] = useState("");
 const [validEmail_Address, setValidEmail_Address] = useState(false);
 const [inputEmail_AddressFocus, setInputEmail_AddressFocus] = useState(false);

 //Checking Valid Tax Number
 const [tax_number, setTax_Number] = useState("");
 const [validtTax_Number, setValidTax_Number] = useState(false);
 const [inputtTax_NumberFocus, setInputTax_NumberFocus] = useState(false);

 //Checking Valid Pacra Number
 const [pacra_number, setPacra_Number] = useState("");
 const [validPacra_Number, setValidPacra_Number] = useState(false);
 const [inputPacra_NumberFocus, setInputPacra_NumberFocus] = useState(false);

 // filter country iso from phone NUmber
 const handlePhoneNumberChange = (country, phone) => {
  setFormData({ ...formData, ["iso_code_2"]: phone.countryCode.toUpperCase(), ["company_mobile_number"]: country });
 };

 const handleSubmit = () => {
  setSubmitError("");
  // Dispatch
  dispatch(
   employee_dashboard_actions_helper(
    loading_edit_user_account_main_details,
    success_edit_user_account_main_details,
    fail_edit_user_account_main_details,
    UPDATE_USER_ACCOUNT_DETAILS_ERR_MSG,
    UPDATE_USER_ACCOUNT_DETAILS_SUCCESS_MSG,
    app_consts.POST,
    EDIT_COMPANY_ACCOUNT_API,
    formData,
    UPDATE_USER_ACCOUNT_DETAILS_ACCESS_DENIED_MSG
   )
  );
 };

 // Listen to Create Loading Order Changes
 const edit_user_account_main_details_listener = useSelector((state) => state.edit_user_account_main_details.edit_user_account_main_details);
 // 
 useEffect(() => {
  if (edit_user_account_main_details_listener.status !== app_consts.IDLE)
  {
   if (edit_user_account_main_details_listener.status === app_consts.LOADING)
   {
    setSubmitError("");
    setSubmitLoading(true);
   } else
   {
    setSubmitLoading(false);
    if (edit_user_account_main_details_listener.status === app_consts.FAIL)
    {
     setSubmitError(edit_user_account_main_details_listener.message);
     messageToast(edit_user_account_main_details_listener.message, app_consts.FAIL);
    } else if (edit_user_account_main_details_listener.status === app_consts.SUCCESS)
    {
     messageToast(UPDATE_USER_ACCOUNT_DETAILS_SUCCESS_MSG, app_consts.SUCCESS);
     successFunction();
     cloasModal();
    }
    dispatch(reset_edit_user_account_main_details());
   }
  }
 }, [edit_user_account_main_details_listener]);


 //Checking States to see if Pacra Number valid or not
 useEffect(() => {
  const result = NUMBERS_ONLY_REGEX.test(pacra_number);
  if (pacra_number?.length !== 12)
  {
   setValidPacra_Number(false);
  } else if (pacra_number?.length === 12)
  {
   setValidPacra_Number(result);
  }
 }, [pacra_number]);

 //Checking States to see if Tax Number valid or not
 useEffect(() => {
  const result = NUMBERS_ONLY_REGEX.test(tax_number);
  if (tax_number?.length !== 10)
  {
   setValidTax_Number(false);
  } else if (tax_number?.length === 10)
  {
   setValidTax_Number(result);
  }
 }, [tax_number]);

 //Checking States to see if Email Address valid or not
 useEffect(() => {
  const result = EMAIL_REGEX.test(email_Address);
  setValidEmail_Address(result);
 }, [email_Address]);

 //Checking States to see if Phone Number is valid or not
 useEffect(() => {
  const result = ZAMIBAN_PHONE_NUMBER_REGEX.test(comp_phone_number);
  setValidPNumber(result);
 }, [comp_phone_number]);

 return (
  <>
   <Modal
    isOpen={open}
    className="modal-dialog-centered"
    size={"lg"}
   >
    <ModalHeader toggle={!loading || !submit_loading ? cloasModal : undefined}>Edit Company Account Details {received_data?.user_account?.unique_identification_number ? `: ${received_data?.user_account?.unique_identification_number}` : ""}</ModalHeader>
    <ModalBody>
     <form
      onSubmit={(e) => {
       e.preventDefault();
      }}
     >
      <Row className="g-4">
       <TextInput
        label="Company Name"
        type="text"
        id_val="company_name"
        value={formData.company_name}
        handleChange={handleChange}
        name="company_name"
        maxlength="100"
        required
       />
       <TextInput
        label="Tax Number"
        type="text"
        id_val="tax_number"
        value={formData.tax_number}
        handleChange={handleChange}
        name="tax_number"
        required
        maxlength="10"
        error_stat={inputtTax_NumberFocus && tax_number && !validtTax_Number ? true : false}
        err_Msg={"Tax Number Should consist of 10 Numerical Characters."}
        onFocus={() => setInputTax_NumberFocus(true)}
       />
       <Col lg="6">
        <div className="form-group">
         <div className="form-label-group">
          <label className="form-label" htmlFor="company_mobile_number">
           Company Mobile Number<span className='text-danger pr-2'>{` *`}</span>
          </label>
         </div>
         <div className="form-control-wrap">
          <PhoneInput
           value={formData.company_mobile_number}
           onChange={(country, phone) => handlePhoneNumberChange(country, phone)}
           copyNumbersOnly={false}
           inputStyle={{ width: '100%' }}
          />
         </div>
        </div>
       </Col>
       <span className="fs-18px text-base fw-bold">Optional</span>
       <TextInput
        label="Company Email Address"
        type="text"
        id_val="company_email_address"
        value={formData.company_email_address}
        handleChange={handleChange}
        name="company_email_address"
        maxlength="160"
        error_stat={inputEmail_AddressFocus && email_Address && !validEmail_Address ? true : false}
        err_Msg={"Please Insert a Valid Email Address."}
        onFocus={() => setInputEmail_AddressFocus(true)}
       />
       <TextInput
        label="Pacra Registration Number"
        type="text"
        id_val="pacra_registration_number"
        value={formData.pacra_registration_number}
        handleChange={handleChange}
        name="pacra_registration_number"
        maxlength="12"
        error_stat={inputPacra_NumberFocus && pacra_number && !validPacra_Number ? true : false}
        err_Msg="Pacra Registration Number Should consist of 12 Numerical Characters."
        onFocus={() => setInputPacra_NumberFocus(true)}
       />
       {submit_error && (
        <div className="mb-3">
         <Alert color="danger" className="alert-icon">
          {" "}
          <Icon name="alert-circle" />
          {submit_error}{" "}
         </Alert>
        </div>
       )}
       <Col xl="12" className="d-flex justify-content-end">
        <Button
         onClick={handleSubmit}
         size="lg"
         type="submit"
         color="primary"
         disabled={
          submit_loading || !(
           formData.company_mobile_number &&
           validtTax_Number &&
           (formData?.pacra_registration_number ? validPacra_Number : true) &&
           (formData?.company_email_address ? validEmail_Address : true) &&
           formData.company_name
          )
         }
        >
         {submit_loading ? <Spinner size="sm" color="light" /> : "Edit Company Details"}
        </Button>
       </Col>
      </Row>
     </form>

    </ModalBody>
   </Modal>
  </>
 );
};

export default EditCompanyDetailsModal;